import { render, staticRenderFns } from "./PaymentsView.yaml?vue&type=template&id=5db3b219&component"
import script from "./PaymentsView.yaml?vue&type=script&lang=ts&component"
export * from "./PaymentsView.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports